document.addEventListener('DOMContentLoaded', function () {
  const styleMapElement = document.getElementById('style-code-map');
  if (!styleMapElement) return;
  
  const currentLocale = document.documentElement.getAttribute('lang') || document.body.dataset.locale || 'en';
  const isFrench = currentLocale.startsWith('fr');
  let styleMap;
  
  try {
    styleMap = JSON.parse(styleMapElement.textContent);
  } catch (e) {
    console.error('Invalid JSON in style-code-map');
    return;
  }
  
  function getSelectedColor() {
    const checkedInput = document.querySelector('input[data-option-position="1"]:checked');
    if (!checkedInput) return null;
    
    const label = document.querySelector(`label[for="${checkedInput.id}"]`);
    const srSpan = label?.querySelector('.sr-only');
    return srSpan ? srSpan.textContent.trim() : null;
  }
  
  function updateStyleCode() {
    const selectedColor = getSelectedColor();
    if (!selectedColor || !styleMap[selectedColor]) {
      console.warn('No valid color selected or style code found');
      return;
    }
    
    const styleCode = styleMap[selectedColor];
    const prefix = isFrench ? 'Code de style : ' : 'Style Code: ';
    const outputs = document.querySelectorAll('.style-code-output');
    
    outputs.forEach(output => {
      const span = document.createElement('span');
      span.className = 'style-code-copy link';
      span.textContent = styleCode;
      
      // Set up copy on click
      span.addEventListener('click', () => {
        navigator.clipboard.writeText(styleCode).catch(err => {
          console.warn('Failed to copy style code:', err);
        });
      });
      
      // Clear and append
      output.textContent = '';
      output.append(prefix, span);
    });
    

    // Trigger the size popover to update popover size_popover pdp_size_pop
    const popoverListbox = document.querySelector('.popover.size_popover.pdp_size_pop');
    
    if (popoverListbox) {

            //need to update the popover content in case their are more than one popoverListbox on the page
      const popoverListboxes = document.querySelectorAll('.popover.size_popover.pdp_size_pop');
      popoverListboxes.forEach(popover => {
        const labels = popover.querySelectorAll('label');

          //check if a label exists with the class is-disabled
          const hasDisabledLabel = Array.from(labels).some(label => label.classList.contains('is-disabled'));

          if (hasDisabledLabel) {

            
            //click the first label in popover that dose not have the class is-disabled 
            for (let i = 0; i < labels.length; i++) {
              const label = labels[i];
              if (!label.classList.contains('is-disabled')) {
                label.click();
                break;
              }
            }
            // Trigger the popover to update its size
            const popover = popoverListbox.closest('x-popover');
            if (popover) {
              popover.dispatchEvent(new Event('close'));
              popover.dispatchEvent(new Event('open'));
            }
      
          }//end of if has Disabled Label

      });

    }//end of if has PopoverListbox

    
  }

  // Also listen for direct swatch clicks as backup
  document.body.addEventListener('click', function (e) {
    if (e.target.closest('.thumbnail-swatch')) {
     
      setTimeout(() => {
      updateStyleCode();
    }, 250);
    }
  });
  
  // Initial load
  updateStyleCode();
});